import store from '../store/index';
export default {
    install: function (Vue) {
        Vue.prototype.$ifauth = function (authRes) {
            return store.getters.hasAuth(authRes);
        };
    }
}